import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/global.css";
// Import the engine for its side effects: defines window.__gpBoot / __gpEngine.
// (No DOM is touched at import time — boot() is deferred until #app exists.)
import "./legacy/engine";
import App from "./App";
import AuthGate from "./components/AuthGate";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthGate>
        <App />
      </AuthGate>
    </BrowserRouter>
  </StrictMode>,
);
